{
    "FormEnginePageElement": {
        "title": "Page"
    },
    "mask": {
        "FormEnginePageElement": {
            "groupTitle": "Page",
            "isDefault": "Use as entry Page"
        }
    }
}